<template>
  <v-card flat class="border rounded-lg">
    <v-card-text>
      <v-list class="pa-0">
        <draggable v-model="actions" handle=".drag-handle" animation="200" @end="syncToParent">
          <v-list-item v-for="(item, index) in actions" :key="item.id" class="border rounded-lg mb-2 pa-2 bg-light d-flex align-center">
            
            <div class="drag-handle mr-2 ml-2" style="cursor: grab;" title="جابجایی">
              <v-icon color="grey">mdi-drag-vertical</v-icon>
            </div>
            
            <div class="flex-grow-1">
              <v-text-field
                v-model="item.label"
                dense
                hide-details
                outlined
                label="عنوان دکمه (قابل ویرایش)"
                @input="syncToParent"
              >
                <template v-slot:prepend-inner>
                   <v-icon small class="mr-1 mt-1">{{ item.icon }}</v-icon>
                </template>
              </v-text-field>
            </div>
            
            <div class="ml-2 mr-4 d-flex align-center">
               <span class="text-caption font-weight-bold ml-2" :class="item.active ? 'success--text' : 'grey--text'">
                 {{ item.active ? 'فعال' : 'غیرفعال' }}
               </span>
               <v-switch
                v-model="item.active"
                dense
                inset
                color="success"
                hide-details
                class="mt-0 pt-0"
                @change="syncToParent"
              ></v-switch>
            </div>
          </v-list-item>
        </draggable>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "AttendanceActionSettings",
  components: { draggable },
  props: {
    // ممکن است آبجکت با کلید actions یا مستقیماً آرایه بیاید
    value: [Array, Object]
  },
  data() {
    return {
      defaultActions: [
        { id: "check_in", label: "ثبت ورود", icon: "mdi-login", color: "success", active: true, outlined: false },
        { id: "check_out", label: "ثبت خروج", icon: "mdi-logout", color: "error", active: true, outlined: true },
        { id: "traffic", label: "ثبت تردد", icon: "mdi-swap-horizontal", color: "primary", active: false, outlined: true },
        { id: "hourly_leave", label: "مرخصی ساعتی", icon: "mdi-clock-out", color: "warning", active: false, outlined: true },
        { id: "mission", label: "ماموریت", icon: "mdi-briefcase-check", color: "info", active: false, outlined: true }
      ],
      actions: []
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.parseValue(newVal);
      }
    }
  },
  methods: {
    parseValue(val) {
      // استخراج آرایه چه مستقیم باشد چه داخل آبجکت actions
      let source = [];
      if (Array.isArray(val)) {
        source = val;
      } else if (val && Array.isArray(val.actions)) {
        source = val.actions;
      }

      if (source && source.length > 0) {
        // اگر داده تغییر کرده بود آپدیت کن
        if (JSON.stringify(source) !== JSON.stringify(this.actions)) {
          this.actions = JSON.parse(JSON.stringify(source));
        }
      } else if (!this.actions.length) {
        this.actions = JSON.parse(JSON.stringify(this.defaultActions));
      }
    },
    syncToParent() {
      // سازگار با هر دو ساختار
      if (this.value && !Array.isArray(this.value) && typeof this.value === "object") {
        this.$emit("input", { ...this.value, actions: this.actions });
      } else {
        this.$emit("input", this.actions);
      }
    }
  }
};
</script>

<style scoped>
.bg-light { background-color: #f8fafc; }
.border { border: 1px solid #e2e8f0; }
</style>
